var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.25,11.25c0-0.41,0.34-0.75,0.75-0.75h20c0.41,0,0.75,0.34,0.75,0.75v15c0,0.41-0.34,0.75-0.75,0.75h-7.19 l-2.28,2.28c-0.29,0.29-0.77,0.29-1.06,0L17.19,27H10c-0.41,0-0.75-0.34-0.75-0.75V11.25z M10.75,12v13.5h6.75 c0.2,0,0.39,0.08,0.53,0.22L20,27.69l1.97-1.97c0.14-0.14,0.33-0.22,0.53-0.22h6.75V12H10.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,18c0.41,0,0.75,0.34,0.75,0.75v4.5c0,0.41-0.34,0.75-0.75,0.75s-0.75-0.34-0.75-0.75v-4.5 C19.25,18.34,19.59,18,20,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,14.5c0.41,0,0.75,0.34,0.75,0.75v0.5c0,0.41-0.34,0.75-0.75,0.75s-0.75-0.34-0.75-0.75v-0.5 C19.25,14.84,19.59,14.5,20,14.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/Support_icon.10121b3025e07ed093f05e935c2405ad.svg";
export { ForwardRef as ReactComponent };